import { useNavigate } from 'react-router-dom';
import { EDITED } from '../../Constants/constants';

export const useTestExecutionActions = ({
  cancelExecution,
  deleteTests,
  refetch,
  selectedToCancelIds,
  setShowCancelModal,
  selectedIds,
  setShowModal,
  setSelectedIds,
  setShowSingleDeleteModal,
  rerunTestExecution,
  getRerunTestExecutionVariables,
  selectedToRerunTest,
  setShowEditModal,
  setShowFavorites,
  setShowScheduled,
  getTestResultsUrl,
  runEditedMutation,
  setSelectedToCancel,
}) => {
  const navigate = useNavigate();
  const onCancelTestExecution = () => {
    cancelExecution({
      variables: { ids: selectedToCancelIds },
    })
      .then(() => {
        window.showMessage('Loading changes', 'loading');
        refetch().then(() => {
          window.hideMessage();
          window.flash('Successfully canceled test execution!', 'success');
        });
      })
      .catch((error) => {
        window.flash(
          'An error occurred. Test Execution could not be canceled',
          'error'
        );
      });
    setShowCancelModal(false);
  };

  const handleMultiSelectFilter = (args, isSelect) => {
    if (isSelect) {
      args.itemData === 'Favorites' && setShowFavorites(true);
      args.itemData === 'Scheduled' && setShowScheduled(true);
    } else if (args.itemData === 'Favorites') {
      setShowFavorites(false);
    } else {
      setShowScheduled(false);
    }
  };

  const deleteSelectedHandler = () => {
    setShowModal(false);

    window.showMessage('Loading changes', 'loading');
    deleteTests({ variables: { idList: selectedIds } })
      .then(() => {
        refetch().then(() => {
          window.flash('Successfully deleted Test Executions!', 'success');
          window.hideMessage();
          setSelectedIds([]);
        });
      })
      .catch((error) => {
        window.flash(
          'An error occurred. Test executions could not be deleted',
          'error'
        );
        window.hideMessage();
      });
  };

  const deleteSingleHandler = () => {
    setShowSingleDeleteModal(false);
    window.showMessage('Loading changes', 'loading');

    deleteTests({ variables: { idList: selectedIds } })
      .then(() => {
        refetch().then(() => {
          window.flash('Successfully deleted Test Execution!', 'success');
          window.hideMessage();
          setSelectedIds([]);
        });
      })
      .catch((error) => {
        window.flash(
          'An error occurred. Test execution could not be deleted',
          'error'
        );
      });
  };

  const rerunAcceptHandler = (newName) => {
    if (newName === '') {
      return;
    }

    rerunTestExecution(
      getRerunTestExecutionVariables(selectedToRerunTest.current.id, newName)
    );
    setShowEditModal(false);
    selectedToRerunTest.current = null;
  };

  // Event Handlers
  const seeTestResultsHandler = (event, testId) => {
    event.stopPropagation();
    const url = getTestResultsUrl(testId);
    window.open(url, '_blank', 'noreferrer');
  };

  const deleteSingleClickHandler = (event, testId) => {
    event?.stopPropagation();
    setSelectedIds([testId]);
    setShowSingleDeleteModal(true);
  };

  const rerunSingleClickHandler = (event, testId, testStatus, testName) => {
    if (testStatus === EDITED) {
      runEditedMutation({
        variables: {
          teId: testId,
        },
      })
        .then((r) => {
          const response = r.data.testsExecutionRunEditedTestExecution;
          if (response === null) {
            window.hideMessage();
            window.flash('Error trying to run test execution', 'error');
          } else {
            window.hideMessage();
            window.flash(`Tests execution successfully started`, 'success');
          }
        })
        .catch((error) => {
          window.hideMessage();
          window.flash('An error occurred', 'error');
        });
      return;
    }
    event.stopPropagation();
    selectedToRerunTest.current = { id: testId, name: testName };
    setShowEditModal(true);
  };

  const scheduleSingleClickHandler = (event, testId) => {
    event?.stopPropagation();
    navigate(`/schedule/${testId}`);
  };

  const cancelExecutionHandler = (testId) => {
    setSelectedToCancel([testId]);
    setShowCancelModal(true);
  };

  return {
    // Actions
    onCancelTestExecution,
    handleMultiSelectFilter,
    deleteSelectedHandler,
    deleteSingleHandler,
    rerunAcceptHandler,
    // Handlers
    seeTestResultsHandler,
    deleteSingleClickHandler,
    rerunSingleClickHandler,
    scheduleSingleClickHandler,
    cancelExecutionHandler,
  };
};
